var _path, _path2, _path3, _path4, _path5, _g, _path6, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNodeJs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 114,
    viewBox: "0 0 200 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.416 91.2312C100.033 91.2312 99.676 91.1302 99.3452 90.9545L95.9503 88.9612C95.4402 88.6845 95.6953 88.5822 95.848 88.5317C96.5374 88.3031 96.6661 88.255 97.3795 87.8508C97.4565 87.8003 97.5599 87.8267 97.6345 87.8748L100.238 89.4147C100.34 89.4652 100.466 89.4652 100.543 89.4147L110.728 83.5849C110.83 83.5344 110.881 83.4333 110.881 83.3082V71.6727C110.881 71.5464 110.829 71.4442 110.728 71.396L100.543 65.5915C100.441 65.541 100.315 65.541 100.238 65.5915L90.0532 71.396C89.9509 71.4466 89.9004 71.5729 89.9004 71.6727V83.3082C89.9004 83.4093 89.9521 83.5368 90.0532 83.5849L92.8357 85.1753C94.3419 85.9332 95.2862 85.049 95.2862 84.1648V72.6809C95.2862 72.5293 95.4138 72.3777 95.593 72.3777H96.8947C97.0474 72.3777 97.2014 72.504 97.2014 72.6809V84.1648C97.2014 86.1582 96.1043 87.3203 94.1891 87.3203C93.602 87.3203 93.1425 87.3203 91.8408 86.6887L89.1605 85.1729C88.4965 84.7939 88.0898 84.0878 88.0898 83.3299V71.6944C88.0898 70.9365 88.4989 70.2303 89.1605 69.8514L99.3452 64.0216C99.9828 63.6679 100.851 63.6679 101.49 64.0216L111.675 69.8514C112.339 70.2303 112.745 70.9365 112.745 71.6944V83.3299C112.745 84.0878 112.336 84.7939 111.675 85.1729L101.49 91.0027C101.153 91.1527 100.788 91.2302 100.418 91.23L100.416 91.2312ZM103.544 83.2312C99.0769 83.2312 98.1578 81.2126 98.1578 79.4959C98.1578 79.3443 98.2853 79.1927 98.4646 79.1927H99.7915C99.9443 79.1927 100.072 79.2938 100.072 79.4333C100.276 80.7711 100.863 81.4267 103.569 81.4267C105.713 81.4267 106.632 80.9455 106.632 79.8111C106.632 79.1554 106.377 78.6754 103.032 78.347C100.25 78.0703 98.5139 77.464 98.5139 75.2673C98.5139 73.2222 100.25 72.0108 103.16 72.0108C106.427 72.0108 108.036 73.1212 108.24 75.544C108.24 75.6198 108.216 75.6956 108.163 75.7726C108.111 75.8231 108.036 75.8736 107.959 75.8736H106.632C106.504 75.8736 106.377 75.7726 106.351 75.6451C106.045 74.2568 105.254 73.8021 103.161 73.8021C100.813 73.8021 100.531 74.6081 100.531 75.2156C100.531 75.947 100.863 76.1744 104.028 76.5786C107.156 76.9828 108.648 77.5627 108.648 79.7341C108.624 81.9548 106.783 83.2168 103.542 83.2168L103.544 83.2312Z",
    fill: "#539E43"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.812 45.7238C68.812 45.2691 68.5569 44.8408 68.1479 44.6135L57.3245 38.4541C57.144 38.353 56.9419 38.3025 56.7374 38.2772H56.6351C56.4306 38.2772 56.2261 38.353 56.0481 38.4541L45.2246 44.6135C44.8156 44.842 44.5605 45.2691 44.5605 45.7238L44.5846 62.2808C44.584 62.3949 44.6146 62.507 44.6731 62.605C44.7317 62.703 44.8159 62.7831 44.9166 62.8366C45.1211 62.9629 45.3762 62.9629 45.5542 62.8366L51.9867 59.2035C52.3957 58.975 52.6508 58.5479 52.6508 58.0932V50.3458C52.6508 49.8911 52.9058 49.4628 53.3148 49.2354L56.0457 47.6715C56.2502 47.5452 56.4787 47.4947 56.7097 47.4947C56.9357 47.487 57.1586 47.5487 57.3485 47.6715L60.0793 49.2354C60.4884 49.464 60.7434 49.8911 60.7434 50.3458V58.0932C60.7434 58.5479 60.9984 58.9762 61.4075 59.2035L67.8399 62.8366C68.0445 62.9629 68.2995 62.9629 68.504 62.8366C68.6048 62.7831 68.689 62.703 68.7475 62.605C68.806 62.507 68.8366 62.3949 68.836 62.2808L68.812 45.7238ZM120.836 22.9329C120.737 22.8829 120.628 22.8569 120.517 22.8569C120.406 22.8569 120.296 22.8829 120.197 22.9329C119.993 23.0592 119.865 23.2613 119.865 23.4862V39.8917C119.865 40.0432 119.788 40.1948 119.637 40.2959C119.566 40.3332 119.487 40.3527 119.407 40.3527C119.327 40.3527 119.248 40.3332 119.177 40.2959L116.47 38.756C116.067 38.5274 115.572 38.5274 115.169 38.756L104.345 44.9395C103.936 45.168 103.681 45.5951 103.681 46.0498V58.3927C103.681 58.8474 103.936 59.2757 104.345 59.5031L115.169 65.6865C115.572 65.9151 116.067 65.9151 116.47 65.6865L127.294 59.5031C127.703 59.2745 127.958 58.8474 127.958 58.3927V27.627C127.958 27.1458 127.703 26.7187 127.294 26.4914L120.836 22.9329ZM119.841 54.3314C119.841 54.4577 119.791 54.5599 119.688 54.608L115.987 56.7277C115.882 56.7783 115.758 56.7783 115.655 56.7277L111.953 54.608C111.851 54.5575 111.8 54.4312 111.8 54.3314V50.0908C111.8 49.9644 111.851 49.8622 111.953 49.8141L115.655 47.6944C115.759 47.6438 115.883 47.6438 115.987 47.6944L119.688 49.8141C119.791 49.8646 119.841 49.9909 119.841 50.0908V54.3314ZM156.854 49.9885C157.263 49.7599 157.492 49.3329 157.492 48.8781V45.8742C157.489 45.6499 157.429 45.4301 157.317 45.2357C157.205 45.0413 157.045 44.8788 156.853 44.7638L146.106 38.6044C145.703 38.3759 145.208 38.3759 144.805 38.6044L133.981 44.7879C133.572 45.0165 133.317 45.4435 133.317 45.8983V58.2411C133.317 58.6959 133.572 59.1241 133.981 59.3515L144.728 65.4086C145.137 65.6372 145.622 65.6372 146.003 65.4086L152.511 61.8237C152.612 61.7701 152.696 61.6901 152.755 61.5921C152.813 61.4941 152.844 61.382 152.843 61.2679C152.844 61.1538 152.813 61.0417 152.755 60.9437C152.696 60.8457 152.612 60.7656 152.511 60.7121L141.636 54.5286C141.432 54.4023 141.304 54.2002 141.304 53.9753V50.1256C141.303 50.0115 141.334 49.8994 141.393 49.8015C141.451 49.7035 141.535 49.6234 141.636 49.5698L145.031 47.6511C145.235 47.5247 145.492 47.5247 145.695 47.6511L149.09 49.5698C149.294 49.6962 149.422 49.8983 149.422 50.1256V53.1548C149.422 53.2687 149.452 53.3806 149.511 53.4783C149.569 53.576 149.653 53.6559 149.754 53.7094C149.958 53.8357 150.213 53.8357 150.418 53.7094L156.85 49.9993L156.854 49.9885Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M145.29 49.4075C145.367 49.357 145.468 49.357 145.545 49.4075L147.615 50.5937C147.692 50.6442 147.742 50.72 147.742 50.8223V53.1946C147.742 53.2403 147.731 53.2852 147.708 53.3251C147.686 53.3649 147.654 53.3983 147.615 53.422L145.545 54.6081C145.468 54.6587 145.367 54.6587 145.29 54.6081L143.221 53.422C143.182 53.3983 143.15 53.3649 143.128 53.3251C143.105 53.2852 143.094 53.2403 143.094 53.1946V50.8223C143.094 50.7212 143.144 50.6454 143.221 50.5937L145.29 49.4075Z",
    fill: "#539E43"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9103 38.6563C86.5073 38.4277 86.0117 38.4277 85.6087 38.6563L74.8622 44.7892C74.4532 45.0178 74.2246 45.4449 74.2246 45.8996V58.1919C74.2272 58.4162 74.2873 58.636 74.3992 58.8304C74.511 59.0248 74.6709 59.1873 74.8634 59.3023L85.6099 65.4352C86.0129 65.6638 86.5085 65.6638 86.9115 65.4352L97.658 59.3023C98.067 59.0737 98.2956 58.6467 98.2956 58.1919V45.8996C98.293 45.6753 98.2328 45.4555 98.121 45.2611C98.0092 45.0667 97.8493 44.9042 97.6568 44.7892L86.9103 38.6563Z",
    fill: "url(#paint0_linear_153_1868)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_153_1868",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 74,
    y: 38,
    width: 25,
    height: 28
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9103 38.6563C86.5073 38.4277 86.0117 38.4277 85.6087 38.6563L74.8622 44.7892C74.4532 45.0178 74.2246 45.4449 74.2246 45.8996V58.1919C74.2272 58.4162 74.2873 58.636 74.3992 58.8304C74.511 59.0248 74.6709 59.1873 74.8634 59.3023L85.6099 65.4352C86.0129 65.6638 86.5085 65.6638 86.9115 65.4352L97.658 59.3023C98.067 59.0737 98.2956 58.6467 98.2956 58.1919V45.8996C98.293 45.6753 98.2328 45.4555 98.121 45.2611C98.0092 45.0667 97.8493 44.9042 97.6568 44.7892L86.9103 38.6563Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_153_1868)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.6839 44.7893L86.8749 38.6564C86.7787 38.5914 86.6704 38.5613 86.5549 38.5312L74.4551 59.0245C74.5549 59.1448 74.6764 59.2482 74.8124 59.3276L85.6106 65.4606C85.9173 65.6374 86.2746 65.6891 86.6055 65.5869L97.9667 45.0419C97.8853 44.9448 97.7905 44.8597 97.6852 44.7893H97.6839Z",
    fill: "url(#paint1_linear_153_1868)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_153_1868",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 74,
    y: 38,
    width: 25,
    height: 28
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9103 38.6563C86.5073 38.4277 86.0117 38.4277 85.6087 38.6563L74.8622 44.7892C74.4532 45.0178 74.2246 45.4449 74.2246 45.8996V58.1919C74.2272 58.4162 74.2873 58.636 74.3992 58.8304C74.511 59.0248 74.6709 59.1873 74.8634 59.3023L85.6099 65.4352C86.0129 65.6638 86.5085 65.6638 86.9115 65.4352L97.658 59.3023C98.067 59.0737 98.2956 58.6467 98.2956 58.1919V45.8996C98.293 45.6753 98.2328 45.4555 98.121 45.2611C98.0092 45.0667 97.8493 44.9042 97.6568 44.7892L86.9103 38.6563Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_153_1868)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.7076 59.3023C98.0144 59.1255 98.2442 58.8211 98.3452 58.4963L86.5004 38.5071C86.1937 38.4566 85.8628 38.4831 85.5813 38.6587L74.8613 44.7652L86.4246 65.6133C86.5926 65.5861 86.7559 65.535 86.9094 65.4617L97.7076 59.3023Z",
    fill: "url(#paint2_linear_153_1868)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.7077 59.3022L86.936 65.4351C86.7838 65.5119 86.62 65.5632 86.4512 65.5867L86.6557 65.9657L98.6015 59.1266V58.975L98.2948 58.4697C98.2443 58.8234 98.0145 59.1254 97.7077 59.3022Z",
    fill: "url(#paint3_linear_153_1868)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.7077 59.3022L86.936 65.4351C86.7838 65.5119 86.62 65.5632 86.4512 65.5867L86.6557 65.9657L98.6015 59.1266V58.975L98.2948 58.4697C98.2443 58.8234 98.0145 59.1254 97.7077 59.3022Z",
    fill: "url(#paint4_linear_153_1868)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_153_1868",
    x1: 89.7095,
    y1: 43.2277,
    x2: 80.398,
    y2: 62.0068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3288,
    stopColor: "#418B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6352,
    stopColor: "#419637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9319,
    stopColor: "#3FA92D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FAE2A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_153_1868",
    x1: 85.0219,
    y1: 53.4863,
    x2: 107.88,
    y2: 36.7858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1376,
    stopColor: "#41873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4032,
    stopColor: "#54A044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7136,
    stopColor: "#66B848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9081,
    stopColor: "#6CC04A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_153_1868",
    x1: 73.8306,
    y1: 52.048,
    x2: 98.6973,
    y2: 52.048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09192,
    stopColor: "#6CC04A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2864,
    stopColor: "#66B848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5968,
    stopColor: "#54A044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    stopColor: "#41873F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_153_1868",
    x1: 73.8317,
    y1: 62.2383,
    x2: 98.6984,
    y2: 62.2383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09192,
    stopColor: "#6CC04A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2864,
    stopColor: "#66B848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5968,
    stopColor: "#54A044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    stopColor: "#41873F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_153_1868",
    x1: 102.321,
    y1: 54.7694,
    x2: 94.61,
    y2: 70.3233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3288,
    stopColor: "#418B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6352,
    stopColor: "#419637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9319,
    stopColor: "#3FA92D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FAE2A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodeJs);
export default __webpack_public_path__ + "static/media/NodeJS.5566af5064defe1939b026d506f1a59f.svg";
export { ForwardRef as ReactComponent };